module.exports = __webpack_public_path__ + "img/contacts-map.ab62a829.png";